import "./Common.scss";

const CardTitle = ({title, children}) => {
  return (
    <div className="card-title-actions">
      <h3 className="card-title">
        {title}
      </h3>

      {children && <div className="card-actions">{children}</div>}
    </div>
  );
};

export default CardTitle;
